/**
 * Utils
 */
import { fetchSpecies, fetchExtraActions, fetchExtraStatuses } from "../../../../utils/api";

/**
 * Hooks
 */
import useToken from "../../../useToken";
import useCachedData from "../../../useCachedData";

/**
 * Get a list of extra forestal species
 * 
 * @returns {Object}
 */
export const useSpecies = () => {
    const { token } = useToken();
    const abortController = new AbortController();
    const fetcher = () => fetchSpecies(token, abortController.signal);

    const { data, loading, error } = useCachedData(
        "forestal-species", // Cache key
        fetcher,
        { useCache: true, forceRefresh: false }
    );

    return { species: data, loading, error };
};

/**
 * Get a list of extra forestal actions
 * 
 * @returns {Object}
 */
export const useActions = () => {
    const { token } = useToken();
    const abortController = new AbortController();
    const fetcher = () => fetchExtraActions(token, abortController.signal);

    const { data, loading, error } = useCachedData(
        "forestal-actions", // Cache key
        fetcher,
        { useCache: true, forceRefresh: false }
    );

    return { actions: data, loading, error };
};

/**
 * Get a list of extra forestal statuses
 * 
 * @returns {Object}
 */
export const useStatuses = () => {
    const { token } = useToken();
    const abortController = new AbortController();
    const fetcher = () => fetchExtraStatuses(token, abortController.signal);

    const { data, loading, error } = useCachedData(
        "forestal-statuses", // Cache key
        fetcher,
        { useCache: true, forceRefresh: false }
    );

    return { statuses: data, loading, error };
};
